<template>
    <div
        class="form-group"
        style="position: relative"
    >
        <div>
            <label class="form-label">
                Cari Konsumen <span class="f-c-blue">*</span>
            </label>
            <SOInputSearch
                id="cari-konsumen"
                placeholder="Ketuk untuk mencari...."
                :value="value"
                autocomplete="off"
                :do-searching="loadKonsumen"
                :delay-time="500"
                :disabled="disableInput"
            />
        </div>
        <div class="d-flex mt-2" v-if="isLoading" style="gap: 5px;">
            <span class="spinner-border spinner-border-sm f-c-midgrey " role="status" aria-hidden="true"></span>
            <span class="f-14 f-c-midgrey">
                Mencari data...
            </span>
        </div>
        <template v-if="!hasSelected">
            <div id="list" class="border-bottom shadow" v-if="listKosumen.length">
                <div
                    class="p-1"
                    v-for="(item, index) in listKosumen"
                    :key="index"
                    @click="select(item)"
                >
                    {{ item.nama }} {{ item.phone ? ' - ' + item.phone : ''}}
                </div>
            </div>
        </template>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { moduleName } from "../store/state";
import SOInputSearch from "@/so-components/global/input/SOInputSearch.vue";
export default {
    name: 'SearchKonsumen',
    components: {
        SOInputSearch
    },
    props: {
        val: {
            type: String,
            default: null
        },
        disableInput: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            listKosumen: [],
            hasSelected: false,
            value: null,
            isLoading: false,
        }
    },
    mounted() {
        this.value = this.val;
        document.addEventListener('click', this.handleclick(e));
    },
    beforeDestroy () {
        document.removeEventListener("click", this.handleclick());
    },
    methods: {
        handleclick(e) {
            if (document.getElementById('list').contains(e.target)){
                // Clicked in box
            } else{
                this.hasSelected = true
            }
        },
        ...mapActions({
            getKonsumenSchedule: `${moduleName}/getListKonsumenSchedule`,
        }),
        async loadKonsumen(v) {
            this.hasSelected = false
            this.listKosumen = []
            if (v == "") {
                this.$emit('selected', {})
                return
            }
            this.isLoading = true
            try {
                const res = await this.getKonsumenSchedule(v)
                if (!res.data.data.length) {
                    this.$toast.warning(`Data Tidak Ditemukan`)
                    this.isLoading = false
                    return
                }
                this.isLoading = false
                this.listKosumen = res.data.data
            } catch (error) {
                this.isLoading = false
                this.$toast.error(error)
            }
        },
        select(item) {
            this.value = item.nama
            this.hasSelected = true
            this.$emit('selected', item)
        }
    }
}
</script>

<style>
#list {
    border: 1px solid #dee2e6!important;
    position: absolute;
    z-index: 1;
    background: white;
    width: 100%;
    overflow: hidden auto; 
    max-height: 400px;
}
#list div:hover{
    background: #5897fb;
    color: white;
}
</style>